import LoginContainer from 'Login/Container/LoginContainer';

export default LoginContainer;
